/* eslint-disable */
import React from 'react'
import { Link } from 'react-router-dom'
import { Grid, Row, Col } from 'react-flexbox-grid'

import { TextBodyOne } from '../../components/text'
import Icon from '../../components/icons'
import icJoin from '../../static/icons/ic-ava-register.svg'
import BackgroundImage from '../../static/images/massage/background-join.svg'
import illustrasiVendorBergabung from '../../static/images/massage/illustrasi-vendor-bergabung.svg'
import { Style } from './massage-join.styles'

const MassageJoin = () => {
  return (
    <Style>
      <img src={BackgroundImage} alt="" />
      <Grid>
        <Row>
          <Col xs={12} sm={12} md={12} lg={6}>
            <div className="card">
              <div className="title">BERGABUNG</div>
              <TextBodyOne display="block" align="left">
                Siapapun anda, bergabunglah bersama Halojasa dan ciptakan
                kehidupan yang lebih baik
              </TextBodyOne>
              <div className="join">
                <Link target="_blank" to="/vendor/register" className="glass-hover">
                  Bergabung Sekarang
                  <Icon
                    size={12}
                    name="chevronRight"
                    className="chevron-right-icon"
                  ></Icon>
                </Link>
                <img src={icJoin} alt="" />
              </div>
            </div>
          </Col>
          <Col xs={12} sm={12} md={12} lg={6}>
            <img src={illustrasiVendorBergabung} alt="" />
          </Col>
        </Row>
      </Grid>
    </Style>
  )
}

export default MassageJoin
